module.exports = __webpack_public_path__ + "resources/help-c1640c5b1dbcb148d31bc07bdf221c66.svg";